var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopLogoDeviceWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6924_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9 0H5.1C3.7474 0 2.45019 0.526784 1.49376 1.46447C0.53732 2.40215 0 3.67392 0 5V18.3333C0 19.6594 0.53732 20.9312 1.49376 21.8689C2.45019 22.8065 3.7474 23.3333 5.1 23.3333H15.3V26.6667H8.5C8.04913 26.6667 7.61673 26.8423 7.29792 27.1548C6.97911 27.4674 6.8 27.8913 6.8 28.3333C6.8 28.7754 6.97911 29.1993 7.29792 29.5118C7.61673 29.8244 8.04913 30 8.5 30H25.5C25.9509 30 26.3833 29.8244 26.7021 29.5118C27.0209 29.1993 27.2 28.7754 27.2 28.3333C27.2 27.8913 27.0209 27.4674 26.7021 27.1548C26.3833 26.8423 25.9509 26.6667 25.5 26.6667H18.7V23.3333H28.9C30.2526 23.3333 31.5498 22.8065 32.5062 21.8689C33.4627 20.9312 34 19.6594 34 18.3333V5C34 3.67392 33.4627 2.40215 32.5062 1.46447C31.5498 0.526784 30.2526 0 28.9 0ZM30.6 18.3333C30.6 18.7754 30.4209 19.1993 30.1021 19.5118C29.7833 19.8244 29.3509 20 28.9 20H5.1C4.64913 20 4.21673 19.8244 3.89792 19.5118C3.57911 19.1993 3.4 18.7754 3.4 18.3333V5C3.4 4.55797 3.57911 4.13405 3.89792 3.82149C4.21673 3.50893 4.64913 3.33333 5.1 3.33333H28.9C29.3509 3.33333 29.7833 3.50893 30.1021 3.82149C30.4209 4.13405 30.6 4.55797 30.6 5V18.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6924_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLogoDeviceWhite);
export default __webpack_public_path__ + "static/media/Desktop-logo-device-white.e0ff334293f5d0f39383967edf198128.svg";
export { ForwardRef as ReactComponent };